import React from "react";
import Input from "../../../../components/FormComponents/Input";
import Label from "../../../../components/FormComponents/Label";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditNumber = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        type="number"
        label={getLabelForKey("default_value")}
        value={editFieldData.default_value}
        name="default_value"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
        <Input
          type="checkbox"
          label={getLabelForKey("backend_validation")}
          checked={editFieldData.validate.backend_validation}
          name="backend_validation"
          size="medium"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
      </div>
      <div className="flex_row w_50">
        <Input
          label={getLabelForKey("length")}
          type="number"
          value={editFieldData.validate.length}
          name="length"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
        />
      </div>
      <div>
        <div className="flex_column gap_1">
          <Label>Range</Label>
          <div className="field_horizontal_container gap_1">
            <Input
              label="Min"
              type="number"
              value={editFieldData.validate.minValue}
              name="minValue"
              onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
            />
            <Input
              label="Max"
              type="number"
              value={editFieldData.validate.maxValue}
              name="maxValue"
              onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
            />
          </div>
        </div>
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditNumber;
